import { render, staticRenderFns } from "./EditPushNotification.vue?vue&type=template&id=31406d6a&"
import script from "./EditPushNotification.vue?vue&type=script&lang=js&"
export * from "./EditPushNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports